import { useSyncExternalStore } from 'react';

// Counters live on window, like intercom/messengerState: the app and project-management
// bundles each bundle their own copy of this module.
const EVENT = 'wb:okr-activity-stack';
const KEY = '__okrActivityStack';
type Key = 'activity' | 'okrSurface';
type Counts = Record<Key, number>;
type Holder = Window & { [KEY]?: Counts };

const counts = (): Counts => {
  const w = window as Holder;
  if (!w[KEY]) w[KEY] = { activity: 0, okrSurface: 0 };
  return w[KEY] as Counts;
};

const hold = (key: Key) => {
  let held = true;
  counts()[key] += 1;
  window.dispatchEvent(new Event(EVENT));
  // Idempotent, so a teardown path that runs twice cannot drive the count negative.
  return () => {
    if (!held) return;
    held = false;
    counts()[key] -= 1;
    window.dispatchEvent(new Event(EVENT));
  };
};

const subscribe = (onChange: () => void) => {
  window.addEventListener(EVENT, onChange);
  return () => window.removeEventListener(EVENT, onChange);
};
const useAny = (key: Key) => useSyncExternalStore(subscribe, () => counts()[key] > 0);

/** An Activity Editor (federated dialog or legacy popup) is open. Returns the release. */
export const holdActivityOpen = () => hold('activity');
/** The OKR Dialog or the KR Side Panel is on screen. Returns the release. */
export const holdOkrSurfaceOpen = () => hold('okrSurface');

export const useActivityOpen = () => useAny('activity');
export const useOkrSurfaceOpen = () => useAny('okrSurface');
